import { FC } from 'react';
import { Text } from 'internalLibrary';
import classes from 'classnames';
import LoadingLottieIcon from './loading-lottie-animation.json';
import Lottie from 'react-lottie-light';
import styles from './Loading.module.scss';

type LoadingProps = {
  title?: string;
  text?: string;
};

const Loading: FC<LoadingProps> = (props) => {
  const { title, text } = props;

  return (
    <div>
      <div className={styles['container']}>
        <div className={classes(styles.wrapper)}>
          <div className={classes(styles.loading)} data-test="css-Spinner">
            <Lottie options={{ animationData: LoadingLottieIcon }} />
          </div>
          {title && (
            <h1
              className={classes(styles.title)}
              data-test="css-Request-Loading-Title"
            >
              {title}
            </h1>
          )}
          {text && (
            <Text
              className={classes(styles.text)}
              text={text}
              kind="p"
              data-test="css-Info"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Loading;
